<template>
  <div style="width: 100%">
    <v-autocomplete
      :items="categories"
      item-text="name"
      item-value="id"
      :value="value"
      @change="handleSelect"
      :loading="loading"
      :search-input.sync="filter"
      placeholder="Selecione um tipo"
      clearable
      cache-items
      return-object
      v-bind="$props"
      hide-details
      outlined
      dense
    >
      <template v-slot:append-item>
        <ScopeProvider scope="products.local_categories.add" v-if="creatable">
          <v-divider></v-divider>
          <v-list-item @click="new_category_dialog = true">
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Novo tipo</v-list-item-content>
          </v-list-item>
        </ScopeProvider>
      </template>
    </v-autocomplete>

    <v-dialog v-model="new_category_dialog" max-width="400">
      <LocalCategoryForm
        @submit="handleNewCategory"
        @cancel="new_category_dialog = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import { index as indexLocalCategories } from "@/services/local_categories";
import LocalCategoryForm from "../forms/LocalCategoryForm";
import ScopeProvider from "../ScopeProvider";

export default {
  name: "local-category-select",
  components: {
    LocalCategoryForm,
    ScopeProvider,
  },
  props: {
    category: Object,
    label: String,
    clearable: Boolean,
    "error-messages": Array,
    name: String,
    autofocus: Boolean,
    creatable: {
      default: false,
      type: Boolean,
    },
  },
  model: {
    prop: "category",
    event: "change",
  },
  data: () => ({
    loading: false,
    filter: null,
    categories: [],
    new_category_dialog: false,
    value: null,
  }),
  methods: {
    handleNewCategory(value) {
      this.handleSelect(value);
      this.new_category_dialog = false;
    },
    handleSelect(value) {
      this.$emit("change", value);
      this.loading = false;
    },
    async getCategories() {
      this.loading = true;
      try {
        const response = await indexLocalCategories({
          filter: this.filter,
          list: true,
        });
        this.categories = response;
      } catch (e) {
        console.log("Falha ao carregar categorias");
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.value = this.category;

    if (this.value?.id) this.categories = [this.value];
  },
  watch: {
    category: function (val) {
      this.value = val;

      if (this.value?.id) this.categories = [this.value];
    },
    filter(val) {
      val && val !== this.category?.name && this.getCategories(val);
    },
  },
};
</script>